import React from 'react';
import { useTranslation } from 'react-i18next';
import { Spring } from '@/components/ui/Spring';
import styles from './styles.module.scss';

export interface ProfileInfoItem {
  label: string;
  value: string;
}

export interface ProfileInfoProps {
  items: ProfileInfoItem[];
  title?: string;
  className?: string;
}

export const ProfileInfo: React.FC<ProfileInfoProps> = ({
  items,
  title,
  className = '',
}) => {
  const { t } = useTranslation('account');
  const displayTitle = title ?? t('profileInfo');
  return (
    <Spring className={`card d-flex flex-column g-16 card-padded ${className}`}>
      <h3>{displayTitle}</h3>
      <ul className="d-flex flex-column justify-content-between flex-1 g-14">
        {items.map((item, index) => (
          <li className={styles.item} key={index}>
            <span className="text-600 text-header">{item.label}:</span>
            <span className={styles.value}>{item.value}</span>
          </li>
        ))}
      </ul>
    </Spring>
  );
};

export default ProfileInfo;
